export enum ConsultMessageType {
  Chat = 0,
  Message = 1,
}
